

import React, { useState } from "react";
import { useForm } from "../../../../../Hooks/UseForm";
import { formZelle } from "../../../../../propsType/Payemnts";
import { validatePagoZelle } from "../../../../../validations/formValidations";
import PagosController from "../../../../../controllers/PagosController";
import Spinner from "../../../../../components/Loading/loadingSpinner/Spinner";
import InputGeneric from "../../../../../components/Inputs/InputGeneric";
import ButtonGeneric from "../../../../../components/Buttons/ButtonGeneric";
import bills from "../../../../../assets/png/bill.png";
import "../../../../css/steps.css";
import Modal from "../../../../../components/Modals/Modal";
import moment from "moment";
import { PaperClipIcon } from "@heroicons/react/solid";
import { UseContextApp } from "../../../../../Global/Context/appContext";
function Zelle({ data, setData, stapsState, setStapsState, back, deatils }) {
  const { pagoZelle } = PagosController();
  const [loading, setLoading] = useState(false);
  const [errorModal, setErrorModal] = useState(false);
  const [message, setMessage] = useState("");
  const [imgModal, setImgModal] = useState(null);
  const [icon, setIcon] = useState(false);
  const [terminos, setTerminos] = useState(null);
  const [toast, setToast] = useState(false);
  const [toast2, setToast2] = useState(false);
  const [toast3, setToast3] = useState(false);
  const [toast4, setToast4] = useState(false);
  const [{ user }] = UseContextApp();
  const [emailCliente, setEmailCliente] = useState(user?.datos?.email);
   const { form, errors, handleChange, handleSubmit, handleBlur } = useForm(formZelle, validatePagoZelle,emailCliente);
  const pagar = async () => {
    const result = handleSubmit();
    if (result === "ok") {
      setLoading(true);
      let newData = {
        confirmacion: form.confirmation,
        cuenta: deatils.nroCuenta,
        nombre: form.nameZelle,
        apellido: form.lastNameZelle,
        monto: data.metodoAPagar,
        email: emailCliente,
        fecha: form.date,
        idPago: Math.round(Math.random() * 10000000000),
      };
      const res = await pagoZelle(newData);
      switch (res.respuesta)
      {
        case "0":
          setStapsState({
            ...stapsState,
            option1: false,
            option2: false,
            option3: false,
            option4: false,
            option5: true,
          });
          setData({
            ...data,
            exitosoZelle: true,
            transaccion: newData.idPago,
            email: newData.email,
          });
          break;
        case "1":
          setStapsState({
            ...stapsState,
            option1: false,
            option2: false,
            option3: false,
            option4: false,
            option5: true,
          });
          setData({ ...data, transaccion: newData.idPago, email: newData.email, monto: newData.monto, fecha: newData.fecha });
          break;
        default:
          setLoading(false);
          setErrorModal(true);
          setIcon(false);
          setMessage(res.descripcion);
          break;

      }
    }
  };
  const copie = (value) => {
    switch (value) {
      /* case 1:
        navigator.clipboard.writeText("Com Voz Communication LLC.");
        setToast(true);
        setTimeout(() => {
          setToast(false);
        }, 800);
        break;
      case 2:
        navigator.clipboard.writeText("comvoz@netuno.net");
        setToast2(true);
        setTimeout(() => {
          setToast2(false);
        }, 800);
        break; */
      case 3:
        navigator.clipboard.writeText("NetUno CA TS.");
        setToast3(true);
        setTimeout(() => {
          setToast3(false);
        }, 800);
        break;
      case 4:
        navigator.clipboard.writeText("pagos@netuno.net");
        setToast4(true);
        setTimeout(() => {
          setToast4(false);
        }, 800);
        break;
      default:
        setToast(false);
        break;
    }
  };
  return (
    <>
      <div className="flex lg:pt-[100px] pt-[210px] flex-col-reverse px-5 pb-6 lg:flex-row lg:pb-7  lg:px-[28px] gap-4 relative">
        <div className="absolute left-0 top-0 w-full ">
          <div className="bg-white w-full px-4 py-5 border-b border-gray-200 sm:px-6">
            <div className="-ml-4 -mt-4 flex justify-between items-center flex-wrap sm:flex-nowrap">
              <div className="ml-4 mt-4">
                <h3 className="text-2xl leading-6 font-medium text-gray-900">
                  Paga y Notifica
                </h3>
                <p className="mt-1 text-sm text-gray-500">
                Completa la información y haz clic en notificar

                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="lg:w-[70%]  ">
          {loading ? (
            <>
              {" "}
              <div className="w-full h-full flex justify-center items-center">
                {" "}
                <Spinner title={"Pago en Proceso. Espere por favor."} />{" "}
              </div>{" "}
            </>
          ) : (
            <>
              <Modal
                active={errorModal}
                message={message}
                setActive={setErrorModal}
                string={icon ? "check" : "error"}
              >
                <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                  {!icon && (
                    <button
                      type="button"
                      onClick={() => setErrorModal(false)}
                      className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                    >
                      Cancelar
                    </button>
                  )}
                </div>
              </Modal>
              <div className="h-full gap-6 lg:gap-0 flex flex-col justify-between lg:pr-[50px] ">
                <div className="sm:grid sm:grid-cols-3 sm:gap-4 mb-5">
                  <dt className="text-sm font-medium text-gray-900">
                    Datos para realizar el Zelle
                  </dt>
                  <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                    <ul
                      role="list"
                      className="border border-gray-200 rounded-md divide-y divide-gray-200"
                    > 
                    {/*Comentarios para ocultar comvoz correo para pago zelle*/}
                      {/* <li className="pl-3 pr-4 py-3 flex items-center justify-between text-sm">
                         <div className="w-0 flex-1 flex items-center">
                          <PaperClipIcon
                            className="flex-shrink-0 h-5 w-5 text-gray-400"
                            aria-hidden="true"
                          />
                          <span className="ml-2 flex-1 w-0 truncate">
                            Pago a nombre de:{" "}
                          </span>
                        </div> 
                        <div className="ml-4 flex-shrink-0 relative">
                          <div
                            class={` ${toast
                              ? "visible transition-all ease-in duration-800 opacity-100 "
                              : "invisible opacity-0"
                              } bg-grey-lightest border-l-4 absolute  bg-white w-[112px] -top-[9px] -right-[16px] border-[#5ab9e5] p-[10px] rounded shadow-lg flex items-center justify-between`}
                            role="alert"
                          >
                            <span class="fa-stack fa-2x sm:mr-2 mb-3">
                              <i class="fas fa-circle text-red-dark fa-stack-2x"></i>
                              <i class="fas fa-hand-paper fa-stack-1x text-white"></i>
                            </span>
                            <div class="sm:text-left text-center sm:mb-0 mb-3 w-128">
                              <p class="text-grey-dark inline-block">
                                Copiando...
                              </p>
                            </div>
                            <i class="fas fa-times mx-4 fa-2x text-grey-darker"></i>
                          </div>
                          <p
                            onClick={() => copie(1)}
                            className="font-medium text-[#5ab9e5] hover:text-[#5ab9e5] "
                          >
                            Com Voz Communication LLC.
                          </p>
                        </div>
                      </li> */} 
                      {/* <li className="pl-3 pr-4 py-3 flex items-center justify-between text-sm">
                        <div className="w-0 flex-1 flex items-center">
                          <PaperClipIcon
                            className="flex-shrink-0 h-5 w-5 text-gray-400"
                            aria-hidden="true"
                          />
                          <span className="ml-2 flex-1 w-0 truncate">
                            Correo para Zelle:{" "}
                          </span>
                        </div>
                        <div className="ml-4 flex-shrink-0 relative">
                          <div
                            class={` ${toast2
                              ? "visible transition-all ease-in duration-800 opacity-100 "
                              : "invisible opacity-0"
                              } bg-grey-lightest border-l-4 absolute  bg-white w-[112px] -top-[9px] -right-[16px] border-[#5ab9e5] p-[10px] rounded shadow-lg flex items-center justify-between`}
                            role="alert"
                          >
                            <span class="fa-stack fa-2x sm:mr-2 mb-3">
                              <i class="fas fa-circle text-red-dark fa-stack-2x"></i>
                              <i class="fas fa-hand-paper fa-stack-1x text-white"></i>
                            </span>
                            <div class="sm:text-left text-center sm:mb-0 mb-3 w-128">
                              <p class="text-grey-dark inline-block">
                                Copiando...
                              </p>
                            </div>
                            <i class="fas fa-times mx-4 fa-2x text-grey-darker"></i>
                          </div>
                          <p
                            onClick={() => copie(2)}
                            className="font-medium text-[#5ab9e5] hover:text-[#5ab9e5] "
                          >
                            comvoz@netuno.net
                          </p>
                        </div>
                      </li> */}
                    </ul>
                  </dd>
                </div>
                <div className="sm:grid sm:grid-cols-3 sm:gap-4 mb-5">
                  <dt className="text-sm font-medium text-gray-900"></dt>
                  <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                    <ul
                      role="list"
                      className="border border-gray-200 rounded-md divide-y divide-gray-200"
                    >
                      <li className="pl-3 pr-4 py-3 flex items-center justify-between text-sm">
                        <div className="w-0 flex-1 flex items-center">
                          <PaperClipIcon
                            className="flex-shrink-0 h-5 w-5 text-gray-400"
                            aria-hidden="true"
                          />
                          <span className="ml-2 flex-1 w-0 truncate">
                            Pago a nombre de:{" "}
                          </span>
                        </div>
                        <div className="ml-4 flex-shrink-0 relative">
                          <div
                            class={` ${toast3
                              ? "visible transition-all ease-in duration-800 opacity-100 "
                              : "invisible opacity-0"
                              } bg-grey-lightest border-l-4 absolute  bg-white w-[112px] -top-[9px] -right-[16px] border-[#5ab9e5] p-[10px] rounded shadow-lg flex items-center justify-between`}
                            role="alert"
                          >
                            <span class="fa-stack fa-2x sm:mr-2 mb-3">
                              <i class="fas fa-circle text-red-dark fa-stack-2x"></i>
                              <i class="fas fa-hand-paper fa-stack-1x text-white"></i>
                            </span>
                            <div class="sm:text-left text-center sm:mb-0 mb-3 w-128">
                              <p class="text-grey-dark inline-block">
                                Copiando...
                              </p>
                            </div>
                            <i class="fas fa-times mx-4 fa-2x text-grey-darker"></i>
                          </div>
                          <p
                            onClick={() => copie(3)}
                            className="font-medium text-[#5ab9e5] hover:text-[#5ab9e5] "
                          >
                            NetUno CA TS.
                          </p>
                        </div>
                      </li>
                      <li className="pl-3 pr-4 py-3 flex items-center justify-between text-sm">
                        <div className="w-0 flex-1 flex items-center">
                          <PaperClipIcon
                            className="flex-shrink-0 h-5 w-5 text-gray-400"
                            aria-hidden="true"
                          />
                          <span className="ml-2 flex-1 w-0 truncate">
                            Correo para Zelle:{" "}
                          </span>
                        </div>
                        <div className="ml-4 flex-shrink-0 relative">
                          <div
                            class={` ${toast4
                              ? "visible transition-all ease-in duration-800 opacity-100 "
                              : "invisible opacity-0"
                              } bg-grey-lightest border-l-4 absolute  bg-white w-[112px] -top-[9px] -right-[16px] border-[#5ab9e5] p-[10px] rounded shadow-lg flex items-center justify-between`}
                            role="alert"
                          >
                            <span class="fa-stack fa-2x sm:mr-2 mb-3">
                              <i class="fas fa-circle text-red-dark fa-stack-2x"></i>
                              <i class="fas fa-hand-paper fa-stack-1x text-white"></i>
                            </span>
                            <div class="sm:text-left text-center sm:mb-0 mb-3 w-128">
                              <p class="text-grey-dark inline-block">
                                Copiando...
                              </p>
                            </div>
                            <i class="fas fa-times mx-4 fa-2x text-grey-darker"></i>
                          </div>
                          <p
                            onClick={() => copie(4)}
                            className="font-medium text-[#5ab9e5] hover:text-[#5ab9e5] "
                          >
                            pagos@netuno.net
                          </p>
                        </div>
                      </li>
                    </ul>
                  </dd>
                </div>
                <div className="h-[80%] gap-[24px] relative  flex flex-col justify-start ">
                  <div className=" flex flex-col lg:grid lg:grid-cols-2 gap-4 lg:gap-10">
                    <InputGeneric
                      title={"Nombre del Titular de la Cuenta Zelle"}
                      value={form.nameZelle}
                      onChange={handleChange}
                      handleBlur={handleBlur}
                      name={"nameZelle"}
                      errorText={errors.nameZelle}
                    />
                    <InputGeneric
                      title={"Apellido del Titular de la Cuenta Zelle"}
                      value={form.lastNameZelle}
                      onChange={handleChange}
                      handleBlur={handleBlur}
                      name={"lastNameZelle"}
                      errorText={errors.lastNameZelle}
                    />
                  </div>
                  <div className="  flex justify-between flex-col lg:grid lg:grid-cols-2 gap-4 lg:gap-10">
                    <InputGeneric
                      type={"date"}
                      maxProps={moment().format("YYYY-MM-DD")}
                      title={"Fecha Exacta de la Transacción"}
                      value={form.date}
                      onChange={handleChange}
                      handleBlur={handleBlur}
                      name={"date"}
                      errorText={errors.date}
                    />
                    <InputGeneric
                      title={"Correo Electrónico Titular del Servicio"}
                      value={emailCliente}
                      onChange={e => setEmailCliente(e.target.value)}
                      handleBlur={handleBlur}
                      name={"email"}
                      //type={"email"}
                      errorText={errors.email}
                    />
                  </div>

                  <div className="">
                    <p className="text-[0.8rem] text-[#798791]">
                    Para notificar debe haber realizado antes  el pago través de su institución  financiera. 
                    </p>
                    <p className="text-[0.8rem] text-[#798791]">
                    De presentar inconvenientes al realizar o notificar su pago, comuníquese con nosotros a través de nuestros diferentes medios de contacto.
                    </p>
                    <p className="text-[0.8rem]  text-[#798791]">
                      Los montos cancelados en divisas están sujetos al IGTF de
                      acuerdo a la Gaceta Oficial N° 42.339 de fecha 17-03-2022.
                    </p>
                  </div>
                  <hr className="pt-[10px] mt-[10px]" />
                
                </div>

                <div className="w-full flex justify-between gap-[50%]">
                  <div className="w-full">
                    <ButtonGeneric funtion={back} text={"Volver"} />
                  </div>
                  <div className="w-full">
                    <ButtonGeneric funtion={pagar} text={"Notificar"} />
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
        <div className="lg:w-[30%] relative sha">
          <div
            className={`bg-[#005dff0a] w-full h-[400px] relative flex justify-center rounded-[5%] 
                    before:content-[''] 
                    before:absolute 
                    before:w-[45px] 
                    before:h-[45px] 
                    before:rounded-full 
                    before:bg-white 
                    before:bottom-[-20px]
                    before:left-[-20px]
                    after:content-[''] 
                    after:absolute 
                    after:w-[45px] 
                    after:h-[45px] 
                    after:rounded-full 
                    after:bg-white 
                    after:bottom-[-20px]
                    after:right-[-20px]
                    `}
          >
            <div
              className={` bg-[url("../public/bgCard.jpg")]  bg-right w-[80%] bg-auto bg-no-repeat flex flex-col justify-between absolute lg:w-[80%] h-[85%] shadow-xl rounded-[10%] top-[-23%]  z-[8] p-[2rem]`}
            >
              <div className="flex w-full justify-center absolute top-0  right-0  ">
                <div className="border-blue-500 border-2 shadow-xl w-[30%] shadowTarjet shadow-blue-500 "></div>
              </div>
              <div className="flex justify-center items-center">
                <div className="w-[90%] object-contain">
                  <img
                    className="w-full object-contain "
                    src={data.metodoPago.logo}
                    alt=""
                  />
                </div>
              </div>
              <div className="h-40% grid gap-[10px]">
                <div className="font-medium text-center">
                  {data.metodoPago.title}{" "}
                </div>
                <div className="flex flex-col justify-between items-center">
                  <div className="font-medium text-center ">
                    {" "}
                    <div className="whitespace-nowrap">
                      Número de cuenta
                    </div>{" "}
                  </div>
                  <div className="text-center"> {deatils.nroCuenta} </div>
                </div>
                <div className="flex flex-col justify-between items-center">
                  <div className="font-medium w-full text-center">Moneda</div>
                  <div className=" w-full text-center">
                    {data?.data?.title}{" "}
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-col justify-end w-full p-5 gap-4">
              <div className="flex justify-between ">
                <div className="text-[#798791] ">
                  {
                    deatils?.deudaTotalVEF < "0" || deatils?.deudaTotalUSD < "0" ?
                      (
                        <>
                          Saldo a favor
                        </>
                      )
                      :
                      (
                        <>
                          Saldo
                        </>
                      )
                  }
                </div>{" "}
                <div className="font-medium">USD {deatils?.deudaTotalUSD} </div>
              </div>
            </div>
          </div>
          <div className="w-full flex justify-center ">
            <div className="w-[100%] border-dashed  border-t-[2px] border-[#c8c8c8] "></div>
          </div>

          <div className="bg-[#005dff0a] h-[100px] rounded-[10%]">
            <div className="w-full p-5 flex justify-between items-center">
              <div>
                <div className="text-[#798791] ">Monto a Pagar</div>
                <div className="text-2xl font-medium">
                  <span className="text-[#798791] pr-2 ">USD</span>
                  {data?.metodoAPagar}
                </div>
              </div>
              <div className="w-[35px] ">
                <img src={bills} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Zelle;
